import * as users from '../../../apis/user'
import { createSelector } from 'reselect'
import * as cookies from '../../../utilties/cookies'
import history from '../../../utilties/history'
import { hideModal, startSaving, stopSaving } from '../core'
import { setSnackbarMessage } from '../../actions'
import VerifyPhoneNumber from '../../../components/VerifyPhoneNumber'

const FETCH_USER_REQUESTED = 'FETCH_USER_REQUESTED'
const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
const FETCH_USER_FAILED = 'FETCH_USER_FAILED'

export const getUserDetailsById = (id) => (dispatch) => {
	if (!id) {
		return dispatch({ type: FETCH_USER_REQUESTED, data: {} })
	}

	return users.fetchUserById(id).then((user) => {
		if (user) {
			return dispatch({ type: FETCH_USER_SUCCESS, data: user })
		} else if(!user || !user.redirectTo) {
			return dispatch({ type: FETCH_USER_FAILED, data: {} })
		}
	})
	return
}

const FETCH_FULL_USER_REQUESTED = 'FETCH_FULL_USER_REQUESTED'
const FETCH_FULL_USER_SUCCESS = 'FETCH_FULL_USER_SUCCESS'
const FETCH_FULL_USER_FAILED = 'FETCH_FULL_USER_FAILED'

export const getFullUserById = (id) => (dispatch) => {
	dispatch({ type: FETCH_FULL_USER_REQUESTED, data: {} })
	return users.fetchFullUserById(id).then((user) => {
		if (user) {
			return dispatch({ type: FETCH_FULL_USER_SUCCESS, data: user })
		} else if(!user || !user.redirectTo) {
			return dispatch({ type: FETCH_FULL_USER_FAILED, data: {} })
		}
	})
	return
}

const FETCH_USER_NOTIFICATION_SETTINGS_REQUESTED = 'FETCH_USER_NOTIFICATION_SETTINGS_REQUESTED'
const FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS = 'FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS'
const FETCH_USER_NOTIFICATION_SETTINGS_FAILED = 'FETCH_USER_NOTIFICATION_SETTINGS_FAILED'

export const getUserNotificationSettingsById = (id) => (dispatch) => {
	dispatch({ type: FETCH_USER_NOTIFICATION_SETTINGS_REQUESTED, data: {} })
	return users.fetchUserNotificationSettingsById(id).then((settings) => {
		if (settings) {
			return dispatch({ type: FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS, data: settings })
		} else if(!settings || !settings.redirectTo) {
			return dispatch({ type: FETCH_USER_NOTIFICATION_SETTINGS_FAILED, data: {} })
		}
	})
	return
}

const UPDATE_USER_DETAILS_REQUESTED = 'UPDATE_USER_DETAILS_REQUESTED'
const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS'
const UPDATE_USER_DETAILS_FAILED = 'UPDATE_USER_DETAILS_FAILED'

export const updateUserDetailsById = (user) => (dispatch) => {
	dispatch({ type: UPDATE_USER_DETAILS_REQUESTED, data: {} })
	return users.updateUserDetailsById(user).then((user) => {
		if (user) {
			dispatch(hideModal())
			return dispatch({ type: UPDATE_USER_DETAILS_SUCCESS, data: user })
		} else {
			return dispatch({ type: UPDATE_USER_DETAILS_FAILED, data: {} })
		}
	})
	return
}

const SET_USER_PATHOLOGIES_AND_PROMS_REQUESTED = 'SET_USER_PATHOLOGIES_AND_PROMS_REQUESTED'
const SET_USER_PATHOLOGIES_AND_PROMS_SUCCESS = 'SET_USER_PATHOLOGIES_AND_PROMS_SUCCESS'
const SET_USER_PATHOLOGIES_AND_PROMS_FAILED = 'SET_USER_PATHOLOGIES_AND_PROMS_FAILED'

export const setInitialUserPathologiesAndProms = (pathology, proms) => (dispatch) => {
	dispatch({ type: SET_USER_PATHOLOGIES_AND_PROMS_REQUESTED, data: {} })

	let user = cookies.get('user')
	return users.setPathologiesAndProms(user.id, [ pathology ], proms, true).then((response) => {
		if (response) {
			dispatch(getFullUserById(user.id))
			return dispatch(hideModal())
		} else {
			//TODO: Show message
			dispatch(setSnackbarMessage('Unable to edit profile. Please enter all required fields.'))
			return dispatch({ type: SET_USER_PATHOLOGIES_AND_PROMS_FAILED, data: {} })
		}
	})
	return
}

const PHONE_VERIFICATION_CODE_REQUESTED = 'PHONE_VERIFICATION_CODE_REQUESTED'
const PHONE_VERIFICATION_CODE_SUCCESS = 'PHONE_VERIFICATION_CODE_SUCCESS'
const PHONE_VERIFICATION_CODE_FAILED = 'PHONE_VERIFICATION_CODE_FAILED'

export const requestPhoneVerificationCode = (phoneCountryCode, phoneNumber, resend) => (dispatch) => {
	dispatch({ type: PHONE_VERIFICATION_CODE_REQUESTED, data: {} })

	dispatch(startSaving());

	return users.requestPhoneVerificationCode(phoneCountryCode, phoneNumber)
		.then((response) => {

			dispatch(stopSaving());

			if (response && response.isSuccessful) {

				dispatch({ type: PHONE_VERIFICATION_CODE_SUCCESS, data: response.data });

				if (resend) {
					dispatch({
						type: 'SET_SNACKBAR_MESSAGE',
						data: {
							message: `app.security.mfa.resend.success`,
							isSuccess: true
						}
					})
				}
			} else {

				if (response) {
					switch (response.errorCode) {
						case 8:
							dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.security.mfa.failed.invalidNumber`,
									isSuccess: false
								}
							})
							break;
						case 24:
							dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.security.mfa.failed.attemptLimitExceeded`,
									isSuccess: false
								}
							})
							break;
						case 25:
							dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.security.mfa.failed.phoneIsAlreadyInUse`,
									isSuccess: false
								}
							})
							break;
						default:
							dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.security.mfa.failed.sendCodeError`,
									isSuccess: false
								}
							})
					}
				}

				dispatch({ type: PHONE_VERIFICATION_CODE_FAILED, data: {} })
			}
		})
}

const COMPLETE_PHONE_VERIFICATION_REQUESTED = 'COMPLETE_PHONE_VERIFICATION_REQUESTED'
const COMPLETE_PHONE_VERIFICATION_SUCCESS = 'COMPLETE_PHONE_VERIFICATION_SUCCESS'
const COMPLETE_PHONE_VERIFICATION_FAILED = 'COMPLETE_PHONE_VERIFICATION_FAILED'

export const completePhoneVerification = (code, onSuccessRedirectUrl) => (dispatch, getState) => {
	dispatch({ type: COMPLETE_PHONE_VERIFICATION_REQUESTED, data: {} })

	dispatch(startSaving());

	return users.completePhoneVerification(code)
		.then((response) => {

			dispatch(stopSaving());

			if (response && response.isSuccessful) {

				dispatch({ type: COMPLETE_PHONE_VERIFICATION_SUCCESS, data: response.data });

				dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: {
						message: `app.security.mfa.setup.success.phoneVerified`,
						isSuccess: true
					}
				})

				let state = getState()
				
				if (state && state.user) {
                    dispatch(updateMFAState(1, true, response.data))
				}

				if (onSuccessRedirectUrl) {
                    history.push(onSuccessRedirectUrl);
                }

				return dispatch(hideModal())

			} else {

				if (response) {
					switch (response.errorCode) {
						case 23:
							dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.security.mfa.failed.invalidCode`,
									isSuccess: false
								}
							})
							break;
					}
				}

				return dispatch({ type: COMPLETE_PHONE_VERIFICATION_FAILED, data: {} })
			}
		})
}

const RESET_PHONE_VERIFICATION_CODE_REQUESTED = 'RESET_PHONE_VERIFICATION_CODE_REQUESTED'

export const resetPhoneVerificationCode = () => (dispatch) => {
	return dispatch({ type: RESET_PHONE_VERIFICATION_CODE_REQUESTED, data: {} });
}

const IGNORE_USER_PATHOLOGIES_AND_PROMS_REQUESTED = 'IGNORE_USER_PATHOLOGIES_AND_PROMS_REQUESTED'
const IGNORE_USER_PATHOLOGIES_AND_PROMS_SUCCESS = 'IGNORE_USER_PATHOLOGIES_AND_PROMS_SUCCESS'
const IGNORE_USER_PATHOLOGIES_AND_PROMS_FAILED = 'IGNORE_USER_PATHOLOGIES_AND_PROMS_FAILED'

export const ignoreInitialUserPathologiesAndProms = () => (dispatch) => {
	dispatch({ type: IGNORE_USER_PATHOLOGIES_AND_PROMS_REQUESTED, data: {} })

	let user = cookies.get('user')
	return users.ignoreInitialPathologiesAndProms(user.id).then((response) => {
		if (response) {
			dispatch(getFullUserById(user.id))
			return dispatch(hideModal())
		} else {
			return dispatch({ type: IGNORE_USER_PATHOLOGIES_AND_PROMS_FAILED, data: {} })
		}
	})
	return
}

const CHECK_MFA_PATIENT_STATE_REQUESTED = 'CHECK_MFA_PATIENT_STATE_REQUESTED'
const CHECK_MFA_STATE_SUCCESS = 'UPDATE_MFA_STATE_SUCCESS'
const CHECK_MFA_STATE_FAIL = 'CHECK_MFA_STATE_FAIL'

export const checkMFAState = () => (dispatch) => {
    dispatch({ type: CHECK_MFA_PATIENT_STATE_REQUESTED, data: null })

    return users.checkMFAState().then((response) => {
		if (response && response.isSuccessful) {
			if (response.data) {
				dispatch({ type: CHECK_MFA_STATE_SUCCESS, data: null })
				return dispatch({
					type: 'SHOW_MODAL',
					data: {
						component: VerifyPhoneNumber,
						options: {
							mode: 'attach',
							modalContainerStyle: { fullWidth: false },
							disableBackdropClick: true
						},
						show: true,
						canClose: false
					}
				})
			}
			return dispatch({ type: CHECK_MFA_STATE_SUCCESS, data: null })
		}
		else {
			return dispatch({ type: CHECK_MFA_STATE_FAIL, data: null })
		}
	})
}

const UPDATE_MFA_USER_STATE_REQUESTED = 'UPDATE_MFA_USER_STATE_REQUESTED'
const UPDATE_MFA_PATIENT_STATE_REQUESTED = 'UPDATE_MFA_PATIENT_STATE_REQUESTED'
const UPDATE_MFA_STATE_SUCCESS = 'UPDATE_MFA_STATE_SUCCESS'
const UPDATE_MFA_STATE_FAILED = 'UPDATE_MFA_STATE_FAILED'

export const updateMFAState = (type, state, mfaSign) => (dispatch) => {
    dispatch({ type: type === 1 ? UPDATE_MFA_USER_STATE_REQUESTED : UPDATE_MFA_PATIENT_STATE_REQUESTED, data: {} })

    return users.updateMFAState(type, state, mfaSign)
        .then((response) => {

            if (response && response.isSuccessful) {
                return dispatch({ type: UPDATE_MFA_STATE_SUCCESS, data: response.data });
            }
            else {
                //dispatch({ type: UPDATE_MFA_STATE_FAILED, data: {} })

                if (response) {
                    let onCloseHandler = { type: UPDATE_MFA_STATE_FAILED, data: {} }

                    switch (response.errorCode) {
						case 2:
                            dispatch({ type: UPDATE_MFA_STATE_FAILED, data: {} })

							return dispatch({
								type: 'SET_SNACKBAR_MESSAGE',
								data: {
									message: `app.general.failed`,
									isSuccess: false
								}
							})
                    case 21:
                        return dispatch({
                            type: 'SHOW_MODAL',
                            data: {
                                component: VerifyPhoneNumber,
                                options: {
                                    mode: 'attach',
                                    modalContainerStyle: { fullWidth: false }
                                },
                                show: true,
                                canClose: true,
                                onClose: onCloseHandler
                            }
                        })
                    case 22:
                        return dispatch({
                            type: 'SHOW_MODAL',
                            data: {
                                component: VerifyPhoneNumber,
                                options: {
                                    mode: 'verify',
                                    modalContainerStyle: { fullWidth: false }
                                },
                                show: true,
                                canClose: true,
                                onClose: onCloseHandler
                            }
                        })
                    }
                }
            }
        })
}


const UPLOAD_USER_IMAGE_REQUESTED = 'UPLOAD_USER_IMAGE_REQUESTED'
const UPLOAD_USER_IMAGE_SUCCESS = 'UPLOAD_USER_IMAGE_SUCCESS'
const UPLOAD_USER_IMAGE_FAILED = 'UPLOAD_USER_IMAGE_FAILED'

export const setPhoto = (id, photo) => (dispatch) => {
	dispatch({ type: UPLOAD_USER_IMAGE_REQUESTED, data: {} })
	let formData = new FormData()
	formData.append('files', photo)
	return users.setUserImage(id, formData).then((response) => {
		if (response) {
			return dispatch({ type: UPLOAD_USER_IMAGE_SUCCESS, data: response })
		} else {
			return dispatch({ type: UPLOAD_USER_IMAGE_FAILED, data: {} })
		}
	})
	return
}

const initial = {
	userDetails: null,
	fullUser: null,
	notificationSettings: null,
    verifyPhoneMask: null,
    isSetupMFARequired: false
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case UPLOAD_USER_IMAGE_SUCCESS:
			return { ...state, userDetails: action.data }
		case FETCH_USER_NOTIFICATION_SETTINGS_SUCCESS:
			return { ...state, notificationSettings: action.data }
		case FETCH_USER_SUCCESS:
			return { ...state, userDetails: action.data }
		case FETCH_FULL_USER_SUCCESS:
			return { ...state, fullUser: action.data }
		case UPDATE_USER_DETAILS_SUCCESS:
			return { ...state, userDetails: action.data }
        case PHONE_VERIFICATION_CODE_SUCCESS:
            return { ...state, verifyPhoneMask: action.data }
        case RESET_PHONE_VERIFICATION_CODE_REQUESTED:
            return { ...state, verifyPhoneMask: null }
        case 'SET_SETUP_MFA_REQUIRED':
			return { ...state, isSetupMFARequired: action.data }
        case 'SIGN_OUT_REQUESTED':
            return initial
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.user

export const userDetailsSelector = createSelector(mainSelector, (user) => user.userDetails)
export const userNotificationSettingsSelector = createSelector(mainSelector, (user) => user.notificationSettings)

export const verifyPhoneMaskSelector = createSelector(mainSelector, (state) => {
    return state ? state.verifyPhoneMask : null;
})

export const isSetupMFARequiredSelector = createSelector(mainSelector, (state) => {
    return state ? state.isSetupMFARequired : false;
})